/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createTrace } from '../../factoriesAny.js';
export var traceDependencies = {
  addDependencies: addDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createTrace: createTrace
};